module.exports = __webpack_public_path__ + "66e8bcdc95fa220a1d8ec5ec249f71a6.pdf";